import BaseAPI from '@/apis/base/baseApi';

class WebsiteWideTaskResultIssuesAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'websiteWideTaskResultIssues';
}

export default new WebsiteWideTaskResultIssuesAPI();
